import { render, staticRenderFns } from "./First5.vue?vue&type=template&id=6437c794&scoped=true&"
import script from "./First5.vue?vue&type=script&lang=js&"
export * from "./First5.vue?vue&type=script&lang=js&"
import style0 from "./First5.vue?vue&type=style&index=0&id=6437c794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6437c794",
  null
  
)

export default component.exports